import type { OversightResultObligationByObligationIdResponseRow as OversightAssessmentObligationOversightResultsByObligationIdResponseRow } from '@risksmart-app/drizzle/src/types';
import type { GetOversightAssessmentObligationAssessmentResultsByObligationIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetOversightAssessmentObligationAssessmentResultsByObligationIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetObligationOversightResultsByObligationIdArgs = {
  obligationId: string;
};

export const useLazyGetObligationOversightResultsByObligationId =
  createLazyQueryHook<
    UseLazyGetObligationOversightResultsByObligationIdArgs,
    OversightAssessmentObligationOversightResultsByObligationIdResponseRow[],
    GetOversightAssessmentObligationAssessmentResultsByObligationIdQuery
  >({
    trpcQuery: (client, { obligationId }) =>
      client.frontend.assessment.oversightAssessmentObligationAssessmentResultsByObligationId.query(
        { obligationId }
      ),
    mapTrpcDataToGraphQL: (data) => ({
      obligation_oversight_result: data,
    }),
    graphqlDocument:
      GetOversightAssessmentObligationAssessmentResultsByObligationIdDocument,
    graphqlVariables: ({ obligationId }) => ({ ObligationId: obligationId }),
  });
